export enum UserType {
  SYSTEM = 0,
  USER = 1,
  PWA = 2
}
